import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ModuleModel } from '../models/module.model';
import { ModuleAddModel } from '../models/module-add.model';
import { ModuleDetailsModel } from '../models/module-details.model';
import { ModuleListModel } from '../models/module-list.model';
import { ModuleAuditListModel } from '../models/module-audit-list.model';
import { ModuleAuditAddModel } from '../models/module-audit-add.model';
import { ModuleQuestionBankListModel } from '../models/module-question-bank-list.model';
import { ModuleQuestionBankAddModel } from '../models/module-question-bank-add.model';
import { ModuleQuestionBankReorderModel } from '../models/module-question-bank-reorder.model';

@Injectable()
export class ModuleService extends ServiceBase {
    private commonUrl: string = this.url + '/Module/';
    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService
    ) {
        super();
    }

    create(model: ModuleAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    update(model: ModuleDetailsModel): Observable<Response> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .put(completeUrl, model).pipe(
                map((response: Response) => response),
                catchError(this.handleError));
    }

    getAll(): Observable<ModuleListModel[]> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .get<ModuleListModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    get(id: string): Observable<ModuleDetailsModel> {
        const completeUrl: string = this.commonUrl + id;
        return this._http
            .get<ModuleDetailsModel>(completeUrl).pipe(
                catchError(this.handleError));
    }

    getModuleAudits(moduleId: string): Observable<ModuleAuditListModel[]> {
        const completeUrl: string = this.commonUrl + 'module-audits/' + moduleId;
        return this._http
            .get<ModuleAuditListModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getModules(): Observable<ModuleModel[]> {
        const completeUrl: string = this.commonUrl + 'modules';
        return this._http
            .get<ModuleModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    addAuditToModule(model: ModuleAuditAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'add-audit';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    addModuleQuestionBank(model: ModuleQuestionBankAddModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'module-question-bank';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    getModuleQuestionBanks(moduleId: string): Observable<ModuleQuestionBankListModel[]> {
        const completeUrl: string = this.commonUrl + 'module-question-bank/' + moduleId;
        return this._http
            .get<ModuleQuestionBankListModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    deleteModuleQuestionBank(moduleId: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'module-question-bank/' + moduleId;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    deleteModule(moduleId: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + moduleId;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    reorderModuleQuestionBank(model: ModuleQuestionBankReorderModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'module-question-bank-reorder';
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }
}
